@if (!hasAdminPermission) {
<nav id="app-footer" role="navigation" aria-label="Main navigation">
    <button 
        class="footer-button" 
        (click)="goToNotification()" 
        [class.active]="isActive('notification')"
        type="button"
        aria-label="Notifications">
        <div class="footer-icon-container">
            <img class="footer-icon-img" src="../../assets/images/notif-paddle-app.png" alt="Notifications icon">
        </div>
    </button>
    <button
        class="footer-button"
        (click)="goToTournaments()"
        [class.active]="isActive('tournaments')"
        type="button"
        aria-label="Tournaments">
        <div class="footer-icon-container">
            <lucide-icon name="trophy" [size]="22"></lucide-icon>
        </div>
    </button>
    <button
        class="footer-button"
        (click)="goToHome()"
        [class.active]="isActive('home')"
        type="button"
        aria-label="Home">
        <div class="footer-icon-container">
            <img class="footer-icon-img" src="../../assets/images/racket-paddle-app.png" alt="Home icon">
        </div>
    </button>
    <button 
        class="footer-button" 
        (click)="goToProfile()" 
        [class.active]="isActive('profile')"
        type="button"
        aria-label="Profile">
        <div class="footer-icon-container">
            <img class="footer-icon-img" src="../../assets/images/person-paddle-app.png" alt="Profile icon">
        </div>
    </button>
</nav>
}
